import { render, staticRenderFns } from "./PartnerNoticeListIframe.vue?vue&type=template&id=1d789ea8&"
import script from "./PartnerNoticeListIframe.vue?vue&type=script&lang=ts&"
export * from "./PartnerNoticeListIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports